import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Layout";
import api from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Blog | Parfaits Imparfaits";
    api.get("/blog").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Seo title="Blog" description="Articles et réflexions sur l'hypnose spirituelle, la transformation intérieure et l'expansion de conscience." canonical="https://www.parfaitsimparfaits.fr/blog" />
      <section className="pt-40 pb-12" data-testid="blog-hero">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <p className="eyebrow mb-5">Le blog</p>
          <h1 className="text-5xl sm:text-6xl font-serif font-light leading-tight text-sand-900">
            Ressources et <em className="text-sand-500">réflexions</em>
          </h1>
          <p className="mt-6 text-lg text-sand-700 max-w-2xl">
            Pensées, exploration et clés pour cheminer vers plus de clarté
            intérieure.
          </p>
        </div>
      </section>

      <section className="py-20" data-testid="blog-list">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          {loading ? (
            <p className="text-sand-600">Chargement…</p>
          ) : posts.length === 0 ? (
            <p className="text-sand-600">Aucun article pour le moment.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
              {posts.map((p, i) => (
                <Link
                  to={`/blog/${p.slug}`}
                  key={p.id}
                  data-testid={`blog-card-${i}`}
                  className="group block rounded-2xl overflow-hidden bg-sand-100 border border-sand-300/60 transition-all hover:-translate-y-1 hover:shadow-xl"
                >
                  {p.cover_image && (
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={p.cover_image}
                        alt={p.title}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                    </div>
                  )}
                  <div className="p-6">
                    <h2 className="text-2xl font-serif text-sand-900 leading-snug">{p.title}</h2>
                    <p className="mt-3 text-sm text-sand-700 line-clamp-3">{p.excerpt}</p>
                    <span className="inline-flex items-center gap-2 mt-5 text-sand-600 text-sm group-hover:text-sand-900 transition-colors">
                      Lire l'article <ArrowRight size={14} />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
